module.exports = __webpack_public_path__ + "img/MCM.fcabafe6.png";